module.exports = __webpack_public_path__ + "static/media/spec_notes.4575b0ad.png";